import {useSearchParams} from "react-router-dom";


interface FetchSessionAppProps {
    redirect_url: string
}

export default function FetchSessionApp(props: FetchSessionAppProps) {
    let [searchParams, _unusedSet] = useSearchParams();
    console.log(searchParams);
    const session = searchParams.get("session");
    localStorage.setItem('session', session === null ? "" : session);
    window.location.href = props.redirect_url;
    return <h3>Redirecting...</h3>
}